import { ImmutableStore } from 'fluxible-immutable-utils';
import Actions from '../constants/Actions';

const defaultState = {
  clientKey: '',
  environments: [
  ]
};

class PublishStore extends ImmutableStore {

  static storeName = 'PublishStore';

  static handlers = {
    [Actions.PUBLISH_LOAD_PUBLICATION]: 'loadPublication'
  };

  constructor(dispatcher) {
    super(dispatcher);
    this.setState(defaultState);
  }

  loadPublication(publication) {
    console.log('PublishStore:loadPublication', publication);
    this.mergeState({
      ...publication
    });
  }

  getPublication() {
    return {
      clientKey: this.get('clientKey'),
      environments: this.get('environments').toJS()
    };
  }
}

export default PublishStore;



// WEBPACK FOOTER //
// ./src/stores/PublishStore.js